/* eslint-disable max-len */
import UseAxios from '../http/http';
import { serviceName } from '../resources/serviceConstants';
import {
  AI_ACCESS_DROP_DOWN_OPTIONS, ADD_AI_ACCESS_REQ, AI_ACCESS_REQ, APPROVE_AI_ACCESS_REQ, DELETE_AI_ACCESS_REQ, UPDATE_AI_ACCESS_REQ,
} from '../resources/endPoint';


const getAuthHeaders = (token) => ({
  'Content-Type': 'application/json',
  token: token || '',
  isAuthToken: true,
});

export const fetchDropDownOptions = ({
  authToken,
  currentEmployeeId,
  isSuperAdmin,
  userInfo,
  optionType,
  projectIds = [],
}) => {
  return UseAxios({
    service: serviceName.MASTER_MS,
    method: 'post',
    url: AI_ACCESS_DROP_DOWN_OPTIONS + `/${optionType}`,
    headers: getAuthHeaders(authToken),
    authRequired: true,
    csrfToken: true,
    payload: {
      userInfo,
      projectIds,
      currentEmployeeId,
      isSuperAdmin,
    },
  });
};

export const getAiAccessRequestById = ({ authToken, requestId }) => {
  return UseAxios({
    service: serviceName.LANDING_MS,
    method: 'get',
    url: `${AI_ACCESS_REQ}/${requestId}`,
    headers: getAuthHeaders(authToken),
    authRequired: true,
    csrfToken: true,
  });
};

export const updateAiAccessRequest = ({
  authToken,
  requestId,
  employeeEmailId,
  employeeId,
  projectId,
  requesterEmployeeId,
  roleDetails = [],
  businessJustification,
  reqAccessTypeId,
  aiToolIds = [],
}) => {
  return UseAxios({
    service: serviceName.LANDING_MS,
    method: 'post',
    url: UPDATE_AI_ACCESS_REQ,
    headers: getAuthHeaders(authToken),
    authRequired: true,
    csrfToken: true,
    payload: {
      request_id: requestId,
      req_access_type_id: reqAccessTypeId,
      employee_email_id: employeeEmailId,
      employee_id: employeeId,
      project_id: projectId,
      ai_tool_ids: aiToolIds,
      business_justification: businessJustification,
      requester_employee_id: requesterEmployeeId,
      role_details: roleDetails,
    },
  });
};

export const deleteAiAccessRequest = ({
  authToken,
  accessRequestId,
  currentUserEmpId,
  currentUserEmailId,
}) => {
  return UseAxios({
    service: serviceName.LANDING_MS,
    method: 'post',
    url: DELETE_AI_ACCESS_REQ,
    headers: getAuthHeaders(authToken),
    authRequired: true,
    csrfToken: true,
    payload: {
      accessRequestId,
      currentUserEmpId,
      currentUserEmailId,
    },
  });
};

export const approveAiAccessRequest = ({
  authToken,
  requestId,
  approvalLevel,
  currentEmployeeId,
  approverEmpId,
  approverName,
  requestStatusId,
  currentEmployeeEmailId,
  isSuperAdmin,
  comment,
  approvedDateTime,
}) => {
  const level = approvalLevel === 'L1' ? 'l1' : 'l2';
  return UseAxios({
    service: serviceName.LANDING_MS,
    method: 'post',
    url: `${APPROVE_AI_ACCESS_REQ}/${requestId}`,
    headers: getAuthHeaders(authToken),
    authRequired: true,
    csrfToken: true,
    payload: {
      level: `${level}_approval`,
      currentEmployeeId,
      [`${level}_approver_emp_id`]: approverEmpId,
      [`${level}_approver_name`]: approverName,
      request_status_id: requestStatusId,
      [`${level}_Approver_comment`]: comment,
      [`${level}_approved_date and time`]: approvedDateTime,
      currentEmployeeEmailId,
      isSuperAdmin,
    },
  });
};

export const addAiAccessRequest = ({
  authToken,
  currentUserEmployeeId,
  employeesIds = [],
  businessJustification,
  reqAccessTypeId,
  projectId,
  aiToolIds = [],
}) => {
  return UseAxios({service: serviceName.LANDING_MS,
    method: 'post',
    url: ADD_AI_ACCESS_REQ,
    headers: getAuthHeaders(authToken),
    authRequired: true,
    csrfToken: true,
    payload: {
      employee_ids: employeesIds,
      project_id: projectId,
      req_access_type_id: reqAccessTypeId,
      ai_tool_ids: aiToolIds,
      business_justification: businessJustification,
      requester_employee_id: currentUserEmployeeId,
    }});
};
